package com.devi3east.bashbuddy.auth.responses

sealed class AuthResult<T>(
    val data: T? = null,
    val accessToken: String? = null,
    val refreshToken: String? = null
) {
    class Authorized<T>(
        data: T,
        accessToken: String,
        refreshToken: String
    ) : AuthResult<T>(data, accessToken, refreshToken)

    class Success<T> : AuthResult<T>()
    class Unauthorized<T> : AuthResult<T>()
    class EmailBlank<T> : AuthResult<T>()
    class PasswordBlank<T> : AuthResult<T>()
    class UserAlreadyExists<T> : AuthResult<T>()
    class InvalidCredentials<T> : AuthResult<T>()
    class UnknownError<T> : AuthResult<T>()
}